import React from 'react'
import { Steper } from '../../styles.style'

const Breadcrumb = ({ step }) => {
	return (
		<Steper className={step > 5 ? 'hide' : null}>
			<ul>
				<li
					className={
						(step === 1 ? 'active' : '') + (step > 1 ? 'before' : '')
					}></li>

				<li
					className={
						(step === 2 ? 'active' : '') + (step > 2 ? 'before' : '')
					}></li>

				<li
					className={
						(step === 3 ? 'active' : '') + (step > 3 ? 'before' : '')
					}></li>
				<li
					className={
						(step === 4 ? 'active' : '') + (step > 4 ? 'before' : '')
					}></li>
				<li
					className={
						(step === 5 ? 'active' : '') + (step > 5 ? 'before' : '')
					}></li>
			</ul>
		</Steper>
	)
}

export default Breadcrumb
